import styled from 'styled-components'

const Container = styled.div`
	text-align: left;

	&:last-child {
		margin-bottom: 0;
	}
`
export { Container }
